import { render, staticRenderFns } from "./LibraryDetailBaseInfo.vue?vue&type=template&id=13fb47d6&scoped=true&"
import script from "./LibraryDetailBaseInfo.vue?vue&type=script&lang=js&"
export * from "./LibraryDetailBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./LibraryDetailBaseInfo.vue?vue&type=style&index=0&id=13fb47d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb47d6",
  null
  
)

export default component.exports